<div [formGroup]="form" class="calendar-grid">
  <!-- calendar moths -->
  <div class="calendar-grid__months-container grid gap-1 grid-cols-12">
    @for (month of months; track month; let monthIndex = $index) {
      <div
        class="calendar-grid__months"
        [attr.data-test]="
          month === selectedMonth ? 'selected-month' : 'unselected-month'
        "
      >
        <a
          [routerLink]=""
          [ngClass]="{
            'calendar-grid__months--selected': month === selectedMonth,
          }"
          (click)="handleMonthClick(monthIndex)"
          >{{ month }}</a
        >
      </div>
    }
  </div>

  <!-- Calendar grid -->
  <div class="calendar-grid__weeks-container grid gap-2.5 grid-rows-5">
    @for (week of allWeeks; track week; let weekIndex = $index) {
      <div
        class="calendar-grid__week grid gap-2.5 grid-cols-7"
        data-test="weeks-container"
      >
        @for (dayEvent of week; track dayEvent; let evtIndex = $index) {
          <div
            class="calendar-grid__day flex flex-col gap-2.5"
            [ngClass]="{
              'calendar-grid--grey-background': !dayEvent.currentMonth,
            }"
          >
            @if (
              form.controls.dates.at(evtIndex + weekIndex * 7);
              as eventFormGroup
            ) {
              <ng-container [formGroup]="eventFormGroup">
                <div
                  class="calendar-grid__day-time flex flex-row justify-between items-center"
                  [ngClass]="{
                    'calendar-grid--white-color': !dayEvent.currentMonth,
                  }"
                >
                  <div class="flex flex-row gap-x-2.5 items-center">
                    <span
                      class="calendar-grid__day-time-number calendar-grid--bold-text"
                    >
                      {{ dayEvent.date | date: 'd' }}
                    </span>
                    <span class="calendar-grid__day-time-day">
                      {{ dayEvent.date | date: 'E' }}
                    </span>
                  </div>
                  @if (selectableDates) {
                    <ss-checkbox
                      [containerClasses]="['!mr-0']"
                      formControlName="selected"
                      (changeValue)="onCalendarDateChecked($event, dayEvent)"
                      (tryClickOnDisabledMode)="tryClickOnDisabledMode()"
                    ></ss-checkbox>
                  }
                </div>
                @if (dayEvent.currentMonth) {
                  @for (
                    detail of dayEvent.eventsDetail;
                    track detail;
                    let eventShowIndex = $index
                  ) {
                    @if (detail.priceGrades) {
                      <div
                        [ssTicketingCalendarHoverState]="{
                          date: getPrettyDate(detail.eventDate!),
                          time: getPrettyTime(detail.eventDate!),
                          show: detail.eventName | uppercase,
                          hide: hideHoverPreview,
                          priceGradeSeatCounts: getPriceGrade(
                            detail.priceGrades!
                          ),
                        }"
                      >
                        <ng-container
                          *ngTemplateOutlet="dayEventInfo"
                        ></ng-container>
                      </div>
                    } @else {
                      <ng-container
                        *ngTemplateOutlet="dayEventInfo"
                      ></ng-container>
                    }
                    <ng-template #dayEventInfo>
                      <div
                        class="calendar-grid__event-slot flex flex-row justify-between items-center"
                        [ngClass]="{
                          'calendar-grid--visibility-hidden':
                            (selectedEventType.label !== 'ALL' &&
                              detail.eventType !== selectedEventType.label) ||
                            detail.outsideComboRange,
                          'calendar-grid--past-event':
                            detail.isPastDate ||
                            detail.inCart ||
                            (eventCompTypeSelected && !detail.availableToBook),
                          'in-cart': detail.inCart,
                        }"
                        [ngStyle]="{ 'background-color': detail.displayColor }"
                        (click)="handleEventSlotTimeClick(detail)"
                        [attr.data-test]="
                          detail.availableSeats > 100 &&
                          !detail.isPastDate &&
                          detail.eventCode !== 'SPLAT24' &&
                          !detail.announcement &&
                          !detail.inCart
                            ? 'available-event'
                            : 'unavailable-event'
                        "
                        [attr.data-date]="detail.eventDate"
                      >
                        <a
                          [routerLink]=""
                          class="calendar-grid__event-slot__time"
                          [ngClass]="{ 'in-cart': detail.inCart }"
                        >
                          <span class="calendar-grid--bold-text">{{
                            detail.eventDate | date: 'h:mm a'
                          }}</span>
                          @if (detail.eventType !== 'SHOW') {
                            <span class="calendar-grid--bold-text">
                              &nbsp;- {{ detail.eventType }}
                            </span>
                          }
                        </a>
                        @if (selectableDates) {
                          @if (
                            eventFormGroup.controls.shows.at(eventShowIndex);
                            as eventShowFormGroup
                          ) {
                            <div [formGroup]="eventShowFormGroup">
                              <ss-checkbox
                                [containerClasses]="['!mr-0']"
                                formControlName="selected"
                                (changeValue)="
                                  onCalendarDateShowChecked(
                                    $event,
                                    dayEvent,
                                    detail.eventDate
                                  )
                                "
                                (tryClickOnDisabledMode)="
                                  tryClickOnDisabledMode()
                                "
                              ></ss-checkbox>
                            </div>
                          }
                        } @else {
                          <span>{{ detail.availableSeats }}</span>
                        }
                      </div>
                    </ng-template>
                  }
                }
              </ng-container>
            }
          </div>
        }
      </div>
    }
  </div>
</div>
